import { render, staticRenderFns } from "./fieldAutoCompleteColaborator.vue?vue&type=template&id=6073d892&v-slot%3Aview=true"
import script from "./fieldAutoCompleteColaborator.vue?vue&type=script&lang=js"
export * from "./fieldAutoCompleteColaborator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6073d892')) {
      api.createRecord('6073d892', component.options)
    } else {
      api.reload('6073d892', component.options)
    }
    module.hot.accept("./fieldAutoCompleteColaborator.vue?vue&type=template&id=6073d892&v-slot%3Aview=true", function () {
      api.rerender('6073d892', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/fieldAutoCompleteColaborator.vue"
export default component.exports